module.exports = __webpack_public_path__ + "static/AdelleSans-Bold-b1dee0ad3f4bdf563167142e0dc796dd.woff";